import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitionNewsPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.news)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.news)
    }

    return description
  }

  get staticTitle() {
    const newsTitle = this.websiteTerms.META_TITLE_COMPETITION_NEWS.format({
      COMPETITION_NAME: this.competitionName,
      SPORT_TYPE: this.competitionSportName,
    });

    return newsTitle;
  }

  get staticDescription() {
    const description = this.websiteTerms.META_DESCRIPTION_COMPETITION_NEWS.format({
      "COMPETITION_NAME": this.competitionName,
      "SPORT_TYPE": this.competitionSportName
    });

    return description;
  }
}